module.exports = "/static/assets/17a70f3f8ca6b0bb83834780b30d12d6.png";